import { defineStore } from 'pinia'
import type { ModalState, showModalDataI } from '@/typescript/types/stores/ModalStore'
import type ModalStore from '@/typescript/types/stores/ModalStore'

export const useModalStore: () => ModalStore = defineStore('modal', {
  state: () =>
    ({
      isLoading: false,
      isShow: false,
      modalType: '',
      options: null,
      title: null,
      startedStage: 1,
      completedStage: null,
    }) as ModalState,
  getters: {},
  actions: {
    setLoader(data: boolean) {
      this.isLoading = data
    },
    showModal(data: showModalDataI) {
      this.modalType = data.type
      this.title = data.title
      this.options = data.options
      this.isShow = true
    },
    hideModal() {
      this.isShow = false
      this.modalType = ''
      this.options = null
    },
    setUnclicable() {
      this.options = {
        ...this.options,
        isUnclosable: true,
      }
    },
    setStartedStage(val: number) {
      this.startedStage = val
    },
    setCompletedStage(val: number) {
      this.completedStage = val
    },
  },
})
